import { createReducer } from 'reduxsauce';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { AuthTypes } from '../actions/auth';

const INITIAL_STATE = {
  user: null,
  error: null,
  loading: false
};

const logoutRequest = () => INITIAL_STATE;

const loginRequest = (state = INITIAL_STATE) => ({
  ...state,
  user: null,
  error: null,
  loading: true
});

const loginSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  error: null,
  user: action.user,
  loading: false
});

const loginFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  loading: false,
  error: action.error
});

export const HANDLERS = {
  [AuthTypes.LOGIN_REQUEST]: loginRequest,
  [AuthTypes.LOGIN_SUCCESS]: loginSuccess,
  [AuthTypes.LOGIN_FAILURE]: loginFailure,
  [AuthTypes.LOGOUT]: logoutRequest
};

export const modal = createReducer(INITIAL_STATE, HANDLERS);

const persistConfig = {
  keyPrefix: 'hls-',
  key: 'user',
  storage
};

export default persistReducer(persistConfig, modal);
